import { Button } from "primereact/button"
import { useNavigate } from "react-router-dom"

const ProjectsButton = ()=>{
    const navigate = useNavigate()

    const handlePage = (e)=>{
        e.preventDefault()
        navigate('/dashboard/projects')
    }
    return (
        <Button onClick={handlePage}>Progetti</Button>
        
    )
}

export default ProjectsButton